import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { GenericDropdownListItem } from '@models/dropdownListItem';
import { ErfassungListItem, ErfassungZuweisenInput, UserInfo, UserItem } from 'app/core/services/api-client';
import { ICanCancel, ITriggerOnClose } from 'app/core/services/custom-window-service/custom-window.service';
import { ErfassungInfoService } from 'app/core/services/erfassung-info/erfassung-info.service';
import { I18nService } from 'app/core/services/i18n/i18n.service';

@Component({
  selector: 'app-assign-to',
  styleUrls: ['./assign-to.component.scss'],
  templateUrl: './assign-to.component.html',
})
export class AssignToComponent implements ICanCancel, ITriggerOnClose {

  public users: GenericDropdownListItem<string>[] = [];
  public selectedUserId: string = undefined;
  private erfassung: ErfassungListItem;

  @Output()
  public closeWindow: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private erfassungInfoService: ErfassungInfoService,
    private i18n: I18nService) {
  }

  public async cancel() {
    this.closeWindow.emit(false);
  }

  public async init(erfassung: ErfassungListItem) {
    const unassignedItem = ({ text: this.i18n.getLocalizedString('components.assignTo.unassigned'), value: null });
    this.users.push(unassignedItem);
    if (erfassung.bearbeiterUid && erfassung.bearbeiter) {
      this.users.push(({ text: erfassung.bearbeiter, value: erfassung.bearbeiterUid }));
    }
    this.selectedUserId = erfassung.bearbeiterUid;
    var users = await this.erfassungInfoService.getAssignableUsers(erfassung.id).toPromise();
    users = users.sort((a, b) => a.name.localeCompare(b.name));
    if (erfassung.bearbeiterUid && users.every(u => u.uid !== erfassung.bearbeiterUid)) {
      users.push(new UserItem({ name: erfassung.bearbeiter, uid: erfassung.bearbeiterUid, givenName: null, familyName: null }));
    }
    this.users = users.map(u => ({ text: u.name, value: u.uid }));
    this.users.unshift(unassignedItem);
    this.erfassung = erfassung;
  }

  public get canAssign() {
    return this.erfassung && 
      (this.erfassung.bearbeiterUid && this.selectedUserId !== this.erfassung.bearbeiterUid ||
      !this.erfassung.bearbeiterUid && this.selectedUserId);
  }

  public async assign() {
    if (this.selectedUserId) {
      const user = this.users.find(u => u.value === this.selectedUserId);
      await this.erfassungInfoService.assign(this.erfassung.id, new ErfassungZuweisenInput({
        bearbeiter: user.text,
        bearbeiterUid: user.value
      })).toPromise();
      this.erfassung.bearbeiter = user.text;
      this.erfassung.bearbeiterUid = user.value;
    } else {
      await this.erfassungInfoService.assign(this.erfassung.id, new ErfassungZuweisenInput({})).toPromise();
      this.erfassung.bearbeiter = null;
      this.erfassung.bearbeiterUid = null;
    }
    this.closeWindow.emit(true);
  }
}
